<template>
  <div class="pt-3">
    <section class="form-col">

      <button class="btn-icon mb-2" @click="goBack" title="wróć">
        <img src="@/assets/images/left-chevron.svg" alt="wróć"/>
        <span>{{ $content.back }}</span>
      </button>

      <div>
        <header class="form-legend">
          <h1 class="font-size-h3 c-gray bb-1 pb-1">{{ $content.receive_gift }}</h1>
        </header>
        <p class="mt-2 c-gray">{{ $content.gift_info[0] }}<br/>{{ $content.gift_info[1] }}</p>
      </div>


      <div class="mt-4 mb-4 pl-0 pr-0">
        <label for="couponCode" class="label">{{ $content.gift_code }}:</label>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <div class="gift flex flex-row flex-wrap">
            <input
              id="couponCode"
              name="couponCode"
              class="form-control"
              type="text"
              v-model="couponCode"/>
            <button
              @click="checkGiftCoupon"
              class="btn btn-outline-primary btn-max">{{ $content.submit }}</button>
          </div>
          <p class="form-error">{{ errors[0] }}</p>
          <p v-show="couponError" class="form-error">{{ $content.coupon_error }}</p>
          <p v-show="couponIsDiscount" class="form-error">{{ $content.coupon_discount_error }}</p>
        </ValidationProvider>
      </div>
    </section>

    <section class="form-col mt-6 mb-6">

      <transition name="fade" mode="out-in">
        <div v-if="giftPlan">
          <header class="form-legend">
            <h1 class="font-size-h3 c-gray bb-1 pb-1">{{ $content.your_gift }}</h1>
          </header>

          <div class="mt-2 p-4 c-bg-white b-shadow">
            <h4 class="font-size-h3 font-marat">
              <span v-if="giftPlan.is_paper_version" >{{ $content.paper_plan }}</span>
              <span v-else>{{ $content.digital_plan }}</span>
            </h4>
            <p class="t-uppercase mt-2">{{ giftPlan.excerpt }}</p>
            <p class="c-gray mt-2">{{ $content.validity_period }}:</p>
            <p class="c-pink">{{ $content.gift_alert}}</p>

            <div>
              <div v-if="$store.state.userData.subscription_type === 'cyclical'" class="mt-2">
                <p class="c-pink">{{ $content.gift_cyclical }}</p>
                <a :href="profileURL" class="btn btn-primary btn-max ml-a mt-2 mr-a">{{ $content.my_profile }}</a>
              </div>

              <div v-else-if="!$store.state.userData.subscription_expires_as_two_weeks && $store.state.userData.subscription_type !== 'cyclical'" class="mt-2">
                <p class="c-pink">{{ $content.gift_expiration}}</p>
                <a :href="profileURL" class="btn btn-primary btn-max ml-a mt-2 mr-a">{{ $content.my_profile }}</a>
              </div>

              <div v-else>
                <button
                  @click="checkAuth(giftPlan.coupon_activation_link)"
                  v-if="giftPlan.coupon_activation_link"
                  class="btn btn-primary btn-max mt-3"
                >{{ $content.receive }}</button>
                <p class="small mt-1 c-gray">{{ $content.gift_auth}}</p>
              </div>

            </div>

          </div>

        </div>
      </transition>

    </section>

    <section class="form-col">
      <SubscriptionFAQ/>
    </section>

  </div>
</template>

<script>
  import { ValidationProvider } from 'vee-validate';
  import SubscriptionFAQ from '../subscription/SubscriptionFAQ';

  export default {
    name: 'GiftForm',
    components: { SubscriptionFAQ, ValidationProvider },
    data() {
      return {
        userSubscriptionType: this.$store.state.userData.subscription_type,
        userSubscriptionUnlocked: this.$store.state.userData.subscription_expires_as_two_weeks,
        couponCode: this.$store.state.couponCode,
        couponError: false,
        couponIsDiscount: false,
        profileURL: 'https://magazynpismo.pl/panel/moj-profil/',
        giftPlan: null,
      }
    },
    mounted() {
      this.checkGiftCoupon();
    },
    methods: {
      checkAuth(link) {
        if (this.$store.state.userAuthenticated) {
          window.location.href = link;
        } else {
          this.$store.state.modalOpened = true;
        }
      },
      checkGiftCoupon() {
        let formData = new FormData();
        formData.append('coupon_code', this.couponCode);
        this.couponError = false;
        this.couponIsDiscount = false;

        this.$http.post('/wp-admin/admin-ajax.php?action=check_coupon', formData)
          .then(response => {
            let couponData = response.data.coupon_plan;

            if (!couponData.ID) {
              this.giftPlan = null;
              this.couponError = true;
              return false;
            }

            if (
              couponData.kind_of_coupon === 'user-coupon' ||
              (couponData.per_month === 0 && couponData.price === '0.00')
            ) {
              this.$store.commit('setCouponCode', { code: this.couponCode });
              this.giftPlan = couponData;
            } else {
              this.giftPlan = null;
              this.couponIsDiscount = true;
            }
          })
          .catch();
      },
      goBack(){
        this.$store.commit('setActiveStep', { activeStep: 'SelectPlanStep' });
        this.$store.commit('setCouponCode', { code: '' });
        localStorage.removeItem('couponCode');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gift {
    align-items: center;
    input {
      max-width: 360px;
      margin-right: 6px;
    }
    button {
      margin-top: 6px;
    }
  }

  .btn-icon {
    background: transparent;
    padding: 8px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
    }
    span {
      font-family: var(--font-scala-serif);
      font-size: var(--font-15);
      margin-left: 8px;
      color: var(--color-gray);
      text-transform: uppercase;
    }
  }
</style>
